/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { StageMappingOverrideInSync } from './stageMappingOverrideInSync';
import type { StageSyncCreate } from './stageSyncCreate';
import type { StageSyncDelete } from './stageSyncDelete';
import type { StageSyncUpdate } from './stageSyncUpdate';

export interface StageSyncRequest {
  /** @maxItems 500 */
  creates?: StageSyncCreate[];
  /** @maxItems 500 */
  updates?: StageSyncUpdate[];
  /** @maxItems 500 */
  deletes?: StageSyncDelete[];
  order?: string[] | null;
  /** @maxItems 500 */
  mapping_overrides?: StageMappingOverrideInSync[];
}
